<template>
  <div class="discussparent">
    <div class="discussleft" v-if="listShow">
      <div class="orderby">
        <label v-bind:class="{active:selectedOrder==1}" v-on:click="selectedOrder=1">
          <span class="orderby-icon-visit" :class="{'active-visit':selectedOrder==1}"></span>{{$t('global.最新')}}
        </label>
        <label v-bind:class="{active:selectedOrder==2}" v-on:click="selectedOrder=2">
          <span class="orderby-icon-zan" :class="{'active-zan':selectedOrder==2}"></span>{{$t('global.按点赞数')}}
        </label>
        <label v-bind:class="{active:selectedOrder==3}" v-on:click="selectedOrder=3">
          <span class="orderby-icon-comment" :class="{'active-comment':selectedOrder==3}"></span>{{$t('global.按评论数')}}
        </label>
      </div>
      <div class="leavemessage">
        <ul>
          <li v-for="(item,index) in questionList" :key="index" class="imgstyle">
            <router-link
              target="_blank"
              :to="`/discussDetail?id=${item.id}&author=${item.userId}&activeIndex=4&topicId=${topicId}`"
            >
              <p
                class="titles"
                style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
              >{{item.title}}</p>
            </router-link>
            <p
              class="titlecontent"
              style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
              v-html="delHtmlTag(item.content)"
            ></p>
            <div class="usermessage">
              <router-link target="_blank" :to="'/peopleCenter/'+item.userId">
                <img class="userhead" :src="item.avatar | imageUrl('/static/profile_img_default.png',40,40)">
                <span class="name">{{item.nickName}}</span>
              </router-link>
              <div class="rightside" v-if="item.answerCount > 0">
                <a>
                  {{item.answerCount}}
                  <em>{{$t('global.回复')}}</em>
                </a>
                <a>{{item.lastAnswerTime}}</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div v-if="questionList.length == 0" style="width:100%;height:500px">
        <content-empty :content="$t('global.没有相关的讨论')"></content-empty>
      </div>

      <div class="searchdiscuss">
        <input type="text" v-model="keyword" :placeholder="$t('global.搜索本组讨论')" @keyup.enter="getQuestionList">
        <img src="/static/search.svg" @click="getQuestionList">
      </div>
      <pages
        :page-size="pagerParam.pageSize"
        :page-count="pagerParam.pageCount"
        :current-page="pagerParam.currentPage"
        :total="pagerParam.total"
        @current-page-changed="OnCurrentPageChanged"
      ></pages>
    </div>
  </div>
</template>

<script>
import pages from "../../components/pages.vue";
import ContentEmpty from "../../components/ContentEmpty";
import discussDetails from "../../pages/subject/discussDetails.vue";
export default {
  name: "discussArea",
  components: {
    /*  discussDetails,*/
    pages,
    ContentEmpty
  },
  props: {
    topicId: {
      type: String
    },
    topicName: {
      type: String
    },
    activeIndex: {
      type: Number
    }
  },
  data() {
    return {
      keyword: "",
      selectedOrder: 1,
      listShow: true,
      detailShow: false,
      publish: false,
      isActive: 0,
      questionList: [],
      pagerParam: {
        pageSize: 6,
        pageCount: 1,
        currentPage: 1,
        total: 1
      }
    };
  },
  created() {
    this.topicId = this.$query.id;
  },
  methods: {
    clickTitle() {
      this.listShow = false;
      this.detailShow = true;
      /*this.$router.push('/discussDetail?id='+id+'&topicId='+this.topicId)*/
    },

    OnCurrentPageChanged(val) {
      this.pagerParam.currentPage = val;
      this.getQuestionList();
    },
    getQuestionList() {
      var aa = this.selectedOrder;
      this.$http
        .get("/api/topic/findQuestionList", {
          params: {
            keyword: this.keyword,
            topicId: this.topicId,
            orderByType: this.selectedOrder,
            pageIndex: this.pagerParam.currentPage,
            pageSize: this.pagerParam.pageSize
          }
        })
        .then(response => {
          this.questionList = response.data.list;
          this.pagerParam = {
            pageSize: response.data.pageSize,
            pageCount: response.data.totalPage,
            currentPage: response.data.pageIndex,
            total: response.data.totalRecord
          };
        });
    }
  },
  created() {
    this.getQuestionList();
  },
  watch: {
    selectedOrder() {
      this.getQuestionList();
    }
  }
};
</script>

<style  scoped>
.discussleft {
  position: relative;
  float: left;
  width: 760px;
  margin-top: 39px;
}
em {
  font-style: normal;
}
.orderby {
  color: #858585;
  font-size: 12px;
  height: 30px;
}
.orderby strong {
  font-size: 16px;
  float: right;
  color: #333;
}
.orderby .active {
  color: #0060ff;
}
.orderby label {
  cursor: pointer;
}
.orderby-icon-time {
  display: inline-block;
  width: 0.16rem;
  height: 0.15rem;
  background: url("/static/explore/time.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}
.orderby-icon-visit {
  display: inline-block;
  width: 0.19rem;
  height: 0.14rem;
  background: url("/static/explore/visit.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
}
.orderby label > span {
  position: relative;
  top: -1px;
}
.orderby-icon-zan {
  display: inline-block;
  width: 0.16rem;
  height: 0.15rem;
  background: url("/static/explore/zan.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.orderby-icon-comment {
  display: inline-block;
  width: 0.16rem;
  height: 0.16rem;
  background: url("/static/explore/comment.png") no-repeat center center;
  background-size: contain;
  vertical-align: bottom;
  margin-right: 0.1rem;
  margin-left: 0.35rem;
}
.orderby .active-time {
  background: url("/static/explore/focusTime.png") no-repeat center center;
  background-size: contain;
}
.orderby .active-visit {
  background: url("/static/explore/focusVisit.png") no-repeat center center;
  background-size: contain;
}
.orderby .active-zan {
  background: url("/static/explore/focusZan.png") no-repeat center center;
  background-size: contain;
}
.orderby .active-comment {
  background: url("/static/explore/focusComment.png") no-repeat center center;
  background-size: contain;
}

.orderby .active-comment[data-v-57d14473] {
  background: url(/static/explore/focusComment.png) no-repeat 50%;
  background-size: contain;
}

.leavemessage li {
  position: relative;
  padding-bottom: 20px;
  margin-top: 20px;
  border-bottom: 1px solid rgba(237, 236, 241, 1);
}
li.imgstyle > a {
  display: block;
  width: 760px;
}
li.imgstyle + div.divheight {
  width: 100%;
  height: 200px;
}
.leavemessage li:last-child {
  margin-bottom: 30px;
}
.leavemessage .titles {
  width: 760px;
  color: #333;
  font-size: 18px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.leavemessage span.question,
.leavemessage span.article {
  position: absolute;
  float: left;
  color: #fff;
  top: 4px;
  left: 0;
  font-size: 12px;
  padding: 1px 7px;
  border-radius: 3px;
}
.leavemessage .titlecontent {
  font-size: 14px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 38px;
  line-height: 19px;
}
.leavemessage span.article {
  background-color: #df7979;
}
.leavemessage span.question {
  background-color: #4a90e2;
}
.leavemessage .usermessage {
  height: 26px;
  margin-top: 20px;
  color: #999;
  font-size: 12px;
}
.leavemessage .usermessage .userhead {
  float: left;
  width: 20px;
  height: 20px;
  border-radius: 13px;
}
.leavemessage .usermessage .name {
  display: inline-block;
  float: left;
  /* height: 20px; */
  color: #999;
  max-width: 150px;
  line-height: 20px;
  margin: 0 20px 0 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.leavemessage .usermessage .rightside {
  float: left;
  height: 20px;
  color: #ccc;
}
.leavemessage .usermessage .rightside a {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  max-width: 70px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.leavemessage .usermessage .rightside a:last-child {
  margin-right: 0;
}
li.imgstyle p > img {
  display: none;
}

.searchdiscuss {
  position: absolute;
  top: -12px;
  right: 0;
  width: 260px;
}
.searchdiscuss input {
  width: 260px;
  height: 32px;
  padding-left: 10px;
  border: 1px solid rgba(237, 236, 241, 1);
  box-sizing: border-box;
}
.searchdiscuss img {
  position: absolute;
  top: 50%;
  left: 89%;
  width: 20px;
  height: 20px;
  transform: translate(0, -50%);
}
</style>



// WEBPACK FOOTER //
// src/pages/subject/discussArea.vue